import { useContext } from 'react';
import { CategoryShowcaseContext } from './CategoryShowcaseContext';

export const useCategoryShowcase = () => {
    const ctx = useContext(CategoryShowcaseContext);
    if (!ctx) throw new Error('useCategoryShowcase must be used inside CategoryShowcaseProvider');
    return ctx;
};
